import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Pennsylvania = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Pennsylvania Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Seller's Property Disclosure Statement: Required by law.
        </Text>

        <Text style={styles.listItem}>
          2. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Property Disclosure Statement</Text>{' '}
          – Property Disclosure Statement mentioning any known material defects
          that could affect the buyer's decision to purchase.
        </Text>
      </View>
    </View>
  );
};

export default Pennsylvania;
